//@flow
import { connect } from 'react-redux';
import CardRegistrationIssue from '../../components/payments/CardRegistrationIssuePage';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { deliveryMethodSelector } from '../../modules/SignUp/DeliveryMethod/selectors';

const mapStateToProps = state => {
  const deliveryMethod = deliveryMethodSelector(state);
  return {
    canSkipPayment: !!deliveryMethod && deliveryMethod.price === 0,
    isLoading: isLoadingSelector(state, 'confirmPlan'),
  };
};

export default connect(mapStateToProps)(CardRegistrationIssue);
